import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import './assets/main.css';
import "./styles/globalStyles.css";
import reportWebVitals from "./reportWebVitals";

const queryString = window.location.search
const urlParams = new URLSearchParams(queryString)
window.$channelGlobal = urlParams.get('canal')
window.$campaignGlobal = urlParams.get('utm_campaign')
window.$mediumGlobal = urlParams.get('utm_medium')
window.$sourceGlobal = urlParams.get('utm_source')
window.$tipoGlobal = urlParams.get('tipo')

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename="/portabilidad">
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
